import React from "react"

import { useRoomFormContext } from "../contexts/RoomFormContext"
import { RoomAirVolumePerAreaInput } from "./inputs/RoomAirVolumePerAreaInput"
import { RoomAirVolumePerPersonInput } from "./inputs/RoomAirVolumePerPersonInput"
import { RoomAreaInput } from "./inputs/RoomAreaInput"
import { RoomHeightInput } from "./inputs/RoomHeightInput"
import { RoomPersonsNumberInput } from "./inputs/RoomPersonsNumberInput"
import { RoomSoundPressureLevelCustomInput } from "./inputs/RoomSoundPressureLevelCustomInput"
import { RoomSoundPressureLevelPresetInput } from "./inputs/RoomSoundPressureLevelPresetInput"
import { RoomUtilizationInput } from "./inputs/RoomUtilizationInput"

export const RoomFormRoomDataTab = React.memo(() => {
  const { isReadonly } = useRoomFormContext()
  return (
    <div className="room-form-room-data-tab room-form__tab-content">
      <RoomUtilizationInput className="room-form-room-data-tab__utilization" />
      <RoomPersonsNumberInput className="room-form-room-data-tab__persons-number" />
      <RoomAirVolumePerAreaInput className="room-form-room-data-tab__air-volume-per-area" />
      <RoomAirVolumePerPersonInput className="room-form-room-data-tab__air-volume-per-person" />
      <RoomAreaInput className="room-form-room-data-tab__area" />
      <RoomHeightInput className="room-form-room-data-tab__height" />
      {isReadonly ? (
        <RoomSoundPressureLevelCustomInput />
      ) : (
        <div className="room-form-room-data-tab__sound-pressure">
          <RoomSoundPressureLevelPresetInput />
          <RoomSoundPressureLevelCustomInput />
        </div>
      )}
    </div>
  )
})
